import React from 'react';
import { PageFrame } from '../../components';
import './Rules.css';

const rules = [
  {
    title: 'Be Respectful',
    desc: 'Treat all players with respect. No harassment, bullying, discrimination, or hate speech of any kind. This includes usernames, skins, and builds.'
  },
  {
    title: 'No Cheating or Exploits',
    desc: 'Hacked clients, x-ray, auto-clickers, duplication glitches, and any form of cheating is strictly prohibited. Play fair or face a permanent ban.'
  },
  {
    title: 'No Griefing',
    desc: "Do not destroy, modify, or steal from other players' builds or items without permission. This includes unclaimed areas if clearly built upon."
  },
  {
    title: 'No Spamming or Advertising',
    desc: 'Keep chat clean. No excessive caps, character spam, or repeated messages. Advertising other servers or services is not allowed.'
  },
  {
    title: 'Keep It Family Friendly',
    desc: 'No inappropriate content in chat, signs, books, or builds. We have players of all ages - keep Voxale welcoming for everyone.'
  },
  {
    title: 'No Real-World Trading',
    desc: 'Trading in-game items or currency for real money, gift cards, or items from other games is forbidden. All trades must be within Voxale.'
  },
  {
    title: 'Respect Staff Decisions',
    desc: "Staff members have the final say. If you believe a decision was unfair, appeal through proper channels on our Discord - not in-game arguments."
  },
  {
    title: 'Use Common Sense',
    desc: "These rules don't cover everything. If something feels wrong, it probably is. When in doubt, ask a staff member before proceeding."
  }
];

const punishments = [
  { icon: '⚠️', name: 'Warning', desc: 'Minor offense' },
  { icon: '🔇', name: 'Mute', desc: 'Chat violations' },
  { icon: '⏰', name: 'Temp Ban', desc: 'Serious offense' },
  { icon: '🚫', name: 'Perm Ban', desc: 'Cheating/severe' }
];

function Rules() {
  return (
    <PageFrame>
      <header className="header">
        <div className="sword-divider">
          <span className="sword-line"></span>
          <span className="sword-icon">📜</span>
          <span className="sword-line"></span>
        </div>
        <h1 className="page-title">Server Rules</h1>
        <p className="page-subtitle">Follow these laws to keep our realm peaceful</p>
      </header>

      <ol className="rules-list">
        {rules.map((rule, index) => (
          <li className="rule-item" key={index}>
            <h3 className="rule-title">{rule.title}</h3>
            <p className="rule-desc">{rule.desc}</p>
          </li>
        ))}
      </ol>

      <div className="vote-rewards" style={{ marginTop: '2rem' }}>
        <h3 className="section-title" style={{ marginTop: 0 }}>
          <span className="title-line"></span>
          Punishments
          <span className="title-line"></span>
        </h3>
        <div className="reward-grid">
          {punishments.map((p, index) => (
            <div className="reward-item" key={index}>
              <div className="reward-icon">{p.icon}</div>
              <div className="reward-name">{p.name}</div>
              <div className="reward-amount">{p.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <p style={{ textAlign: 'center', marginTop: '2rem', color: 'var(--wood-medium)', fontSize: '0.95rem' }}>
        By playing on Voxale, you agree to follow these rules.<br />
        Rules may be updated at any time - check back regularly!
      </p>
    </PageFrame>
  );
}

export default Rules;
